import { apiRequest } from './api';
import { decodeProblemSubmissions } from './decoders';

const isObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value);
const isString = (value) => typeof value === 'string';
const count = (value) => (Number.isInteger(value) && value >= 0 ? value : 0);

const STATUSES = ['solved', 'attempted', 'unattempted'];

function decodeCourseInfo(item) {
  if (!isObject(item) || !Number.isInteger(item.id) || !isString(item.title)) return null;
  return {
    id: item.id,
    title: item.title,
    description: isString(item.description) ? item.description : '',
    createdAt: isString(item.createdAt) ? item.createdAt : null,
  };
}

function decodeCourseSummary(item) {
  const course = decodeCourseInfo(item);
  if (!course) return null;
  return { ...course, questionCount: count(item.questionCount), solvedCount: count(item.solvedCount) };
}

function decodeCourseQuestion(item) {
  if (!isObject(item) || !Number.isInteger(item.id) || !isString(item.title) || !isString(item.difficulty)) return null;
  return {
    id: item.id,
    title: item.title,
    difficulty: item.difficulty,
    tags: Array.isArray(item.tags) ? item.tags.filter(isString) : [],
    submissionCount: count(item.submissionCount),
    acceptedCount: count(item.acceptedCount),
    status: STATUSES.includes(item.status) ? item.status : 'unattempted',
  };
}

export function decodeCourses(data) {
  if (!isObject(data) || !Array.isArray(data.courses)) return null;
  return data.courses.map(decodeCourseSummary).filter(Boolean);
}

export function decodeCourse(data) {
  if (!isObject(data) || !Array.isArray(data.questions)) return null;
  const course = decodeCourseInfo(data.course);
  if (!course) return null;
  return { course, questions: data.questions.map(decodeCourseQuestion).filter(Boolean) };
}

export const courseApi = {
  list: () => apiRequest('/courses', {}, decodeCourses),
  get: (courseId) => apiRequest(`/courses/${courseId}`, {}, decodeCourse),
  submit: (courseId, problemId, body) =>
    apiRequest(`/courses/${courseId}/problems/${problemId}/submit`, { method: 'POST', body }),
  submissions: (courseId, problemId) =>
    apiRequest(`/courses/${courseId}/problems/${problemId}/submissions`, {}, decodeProblemSubmissions),
};
